import * as React from "react";

import { useDrawerDelivery_asController } from "../providers";

import { Fragment_Delivery } from "../fragment-delivery";

export const DrawerFragment_Delivery_Content: React.FunctionComponent =
  () => {
    const { handleClose } = useDrawerDelivery_asController();

    return (
      <section className="bbnt-checkout-2022-delivery-drawer-content">
        <h1>{`Your Order`}</h1>

        <Fragment_Delivery />

        <button onClick={handleClose}>{`BACK TO CHECKOUT`}</button>
      </section>
    );
  };
